.grid {
  grid-template-columns: repeat(4, 1fr);
}

.option {
  align-items: flex-start;
  height: 112px;
}

@media (--reefer-media-tablet-max) {
  .grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .option {
    height: auto;
    min-height: 104px;
  }
}
